<template>
  <div v-if="section_binder_visible">
    <span class="title">Click one or more binders to see available {{ SecTitle }}: </span>  
    <button class="selectAll" type="button" v-on:click="check_all_thing"> Select All </button>  
    <div  class="cardList" >
      <binderCard v-on:click_checkbox = "click_checkbox"
        v-for              = "(card, index) in binderData"
        v-bind:key         = "index"
        v-bind:img         = "card.binder_img"
        v-bind:binderId    = "card.binder_id"
        v-bind:warheadName = "card.warhead_name" 
        v-bind:checked     = "card.checked" /> 
    </div>
    <hr /> 
  </div> 
</template>
 
<script> 

import binderCard from './binderCard.vue'; 

export default {
  name: 'binderSection', 
  props : ["SecTitle", 'binderData', 'section_binder_visible'],
  methods: { 
    click_checkbox: function (cardName) { 
      this.$emit('click_checkbox', cardName);
    },
    check_all_thing: function () {
      this.$emit('check_all_thing', 'checkbox_binder'); 
    }
  },  
  components: {
    binderCard
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>   
  .cardList {
    display: flex;
    flex-direction: row; 
    flex-wrap: wrap;
  } 
  .selectAll {
    font-size: 1.5em;
    font-weight: bold;
  }
  .title {
    font-size: 2em;
    font-weight: bold;
  }
</style>
